import { ColDef, GridApi } from 'ag-grid-community';
import { ReactNode } from 'react';
import { FilterFormData } from '../Data/ApiTypes';
import { DataEntitiesReportsReportType, ServerTransferSavedReportResponse } from '../shared/api/axios-client';

export interface BaseFilter {
    page: number;
    pageSize: number;
    facilityId?: number;
    facilityIds?: number[];
}

export interface ReportConfig<TData, TFilter extends BaseFilter> {
    id: string;
    title: string;
    icon: ReactNode;
    description: string;
    defaultColumns: ColDef<TData>[];
    filterFields: FilterField[];
    facilities?: Array<{ facilityId: number; name: string }>;
    getData: (filter: TFilter) => Promise<{ items: TData[]; total: number }>;
    transformData?: (data: any[]) => TData[];
    defaultFilterForm: FilterFormData;
}

export interface FilterField {
    name: string;
    label: string;
    type: 'text' | 'email' | 'date' | 'select' | 'multiselect' | 'dateRange';
    placeholder?: string;
    options?: { value: string; label: string }[];
    colSize?: number;
}

export interface ReportProps<TData, TFilter extends BaseFilter> {
    facilityId?: number;
    config: ReportConfig<TData, TFilter>;
    savedReports: ServerTransferSavedReportResponse[];
}

export interface ReportState<TData, TFilter extends BaseFilter> {
    data: TData[];
    total: number;
    filter: TFilter;
    filterForm: FilterFormData;
    columnDefs: ColDef<TData>[];
    columnVisibility: Record<string, boolean>;
    gridApi: GridApi | null;
    showGrid: boolean;
    showArrow: boolean;
}

export interface ReportContext<TData, TFilter extends BaseFilter> {
    state: ReportState<TData, TFilter>;
    setState: (state: Partial<ReportState<TData, TFilter>>) => void;
    handleFilterChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
    handleSubmit: (e: React.FormEvent) => void;
    handleReset: () => void;
    toggleColumn: (field: string, show: boolean) => void;
    toggleAllColumns: (show: boolean) => void;
} 

export interface SavedReport {
  id: number;
  name: string;
  type: DataEntitiesReportsReportType
};

export enum Frequency {
  Daily = 0,
  Weekly = 1,
  Monthly = 2,
}